import { render, staticRenderFns } from "./AidexMg.vue?vue&type=template&id=0c407a67&scoped=true&"
import script from "./AidexMg.vue?vue&type=script&lang=js&"
export * from "./AidexMg.vue?vue&type=script&lang=js&"
import style0 from "./AidexMg.vue?vue&type=style&index=0&id=0c407a67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c407a67",
  null
  
)

export default component.exports